import './css/main.scss';
import 'reflect-metadata';
import '@getaccept/lib-shared/src/polyfills';
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import LibUi from '@getaccept/lib-ui';
import VueSignaturePad from 'vue-signature-pad';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueRouter from 'vue-router';
import { VueQueryPlugin } from '@tanstack/vue-query';
import TeleportModal from '@getaccept/lib-shared/src/portal/components/TeleportModal.vue';
import AppWrapper from './AppWrapper.vue';
import router from './router/router';
import store from './store/store';
import i18n from './lang';
import './init';
import 'focus-visible';

if (process.env.NODE_ENV === 'development') {
  console.log(`%c🚀 Running "app-site-old" locally 🚀`, 'font-size: 1rem; line-height: 2rem;');
}
console.log(`%c😔 Running Vue2 version of app-site 😔`, 'font-size: 1rem; line-height: 2rem;');

Vue.config.productionTip = false;
Vue.use(LibUi);
Vue.use(VTooltip, { defaultHtml: false });
Vue.use(VueSignaturePad);
Vue.use(PiniaVuePlugin);
Vue.use(VueRouter);
Vue.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  },
});

// Temporary solution for modal portals:
// Override global definition for BaseModal to use TeleportModal, which
// teleports the modal to a portal target. After conversion to vue3 this can be switched
// to native vue solution.
Vue.component('BaseModal', TeleportModal);

const app = new Vue({
  router,
  store,
  i18n,
  pinia: createPinia(),
  render: h => h(AppWrapper),
});

app.$mount('#app');

(window as any).vueHandle = app;
